var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useMemo } from "react";
import { Schema } from "@al/aku-lc-schema";
import { useWidget } from "../hooks";
import { CreateRootContext, SchemaContext, ArrayItemContext } from "../context";
import { Widget } from "./Widget";
export function RecursionWidget(props) {
    var schema = new Schema(props.schema, props.version);
    var parent = useWidget();
    var options = useContext(CreateRootContext);
    var arrayItem = useContext(ArrayItemContext);
    if (!options) {
        return null;
    }
    var widgetProps = useMemo(function () { return schema.toWidgetProps(options); }, [schema]);
    // TODO: path 补全
    // @ts-expect-error 111
    widgetProps.path = widgetProps.path || props.name;
    if (arrayItem) {
        widgetProps.rowData = arrayItem.rowData;
        widgetProps.columnValue = arrayItem.value;
        widgetProps.columnIndex = arrayItem.index;
    }
    // 获取父级 widget 组件 path
    var getBasePath = function () {
        if (props.onlyRenderChildren) {
            return props.basePath || (parent === null || parent === void 0 ? void 0 : parent.path.concat("/" + (props.name || new Date())));
        }
        return props.basePath || (parent === null || parent === void 0 ? void 0 : parent.path);
    };
    var basePath = getBasePath();
    var renderChildren = function (widget, force) {
        var children = schema.mapChildren(function (item, index) {
            var base = (widget === null || widget === void 0 ? void 0 : widget.path) || basePath;
            return (React.createElement(RecursionWidget, { key: index, version: item.version, form: widget === null || widget === void 0 ? void 0 : widget.form, basePath: base, schema: item, name: props.name, force: force }));
        });
        return children.length ? children : null;
    };
    if (props.onlyRenderChildren) {
        return React.createElement(React.Fragment, null, renderChildren(undefined, props.force));
    }
    return (React.createElement(SchemaContext.Provider, { value: schema },
        React.createElement(Widget, __assign({}, widgetProps, { basePath: basePath, form: props.form, force: props.force || widgetProps.forceUpdate }), renderChildren)));
}
